"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _course = require("./course");

Object.keys(_course).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _course[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _course[key];
    }
  });
});

var _enrollment = require("./enrollment");

Object.keys(_enrollment).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _enrollment[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _enrollment[key];
    }
  });
});

var _section = require("./section");

Object.keys(_section).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _section[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _section[key];
    }
  });
});

var _user = require("./user");

Object.keys(_user).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _user[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _user[key];
    }
  });
});

var _student = require("./student");

Object.keys(_student).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _student[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _student[key];
    }
  });
});

var _teacher = require("./teacher");

Object.keys(_teacher).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _teacher[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _teacher[key];
    }
  });
});

var _reference = require("./reference");

Object.keys(_reference).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _reference[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _reference[key];
    }
  });
});